import fetch from '@/utils/fetch';

export function msgCreate(query) {   // 创建
    return fetch({
        url: '/Shangxun/Shangxun/saveBusinessNews',
        method: 'post',
        data: query
    });
}

export function msgList(query) {   // 列表
    return fetch({
        url: '/Shangxun/Shangxun/getBusinessNewsByKeywordAndType',
        method: 'post',
        data: query
    });
}

export function statusSet(query) {   // 状态更新
    return fetch({
        url: '/Shangxun/Shangxun/updateStatusBusinessNews',
        method: 'post',
        data: query
    });
}

export function msgRemove(query) {   // 删除
    return fetch({
        url: '/Shangxun/Shangxun/batchDeleteBusinessNews',
        method: 'post',
        data: query
    });
}

export function msgPredat(query) {   // 删除
    return fetch({
        url: '/Shangxun/Shangxun/getBusinessNewsById',
        method: 'post',
        data: query
    });
}

export function adsCreate(query) {   // 办公选址
    return fetch({
        url: '/Shangxun/Shangxun/saveBusinessOfficeLocation',
        method: 'post',
        data: query
    });
}

export function assCreate(query) {   // 商协会
    return fetch({
        url: '/Shangxun/Shangxun/saveBusinessAssociationDetails',
        method: 'post',
        data: query
    });
}

export function quCreate(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/saveCommonProblem',
        method: 'post',
        data: query
    });
}

export function quItem(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/getCommonProblemById',
        method: 'post',
        data: query
    });
}

export function quRelate(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/getCommonRelatedProblemWhereByFileds',
        method: 'post',
        data: query
    });
}

export function quRemove(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/batchDeleteCommonProblem',
        method: 'post',
        data: query
    });
}

export function quSet(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/batchUpdateCommonProblemStatus',
        method: 'post',
        data: query
    });
}

export function quRelateSave(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/batchSaveCommonRelatedProblemProblemId',
        method: 'post',
        data: query
    });
}

export function quList(query) {   // 问题库
    return fetch({
        url: '/Cqjcom/Cqjcom/getCommonProblemWhereByFileds',
        method: 'post',
        data: query
    });
}

export function qukCreate(query) {   // 快捷回复
    return fetch({
        url: '/Cqjcom/Cqjcom/saveCustomerServiceMessage',
        method: 'post',
        data: query
    });
}

export function qukItem(query) {   // 快捷回复
    return fetch({
        url: '/Cqjcom/Cqjcom/getCustomerServiceMessageById',
        method: 'post',
        data: query
    });
}


export function qukList(query) {   // 快捷回复
    return fetch({
        url: '/Cqjcom/Cqjcom/getCustomerServiceMessageWhereByFileds',
        method: 'post',
        data: query
    });
}

export function qukRemove(query) {   // 快捷回复
    return fetch({
        url: '/Cqjcom/Cqjcom/batchDeleteCustomerServiceMessage',
        method: 'post',
        data: query
    });
}

export function qukSet(query) {   // 快捷回复
    return fetch({
        url: '/Cqjcom/Cqjcom/batchUpdateCustomerServiceMessageStatus',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/message/message.js